import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../src/assets/images/floatImg01.png'


const _withScopeId = n => (_pushScopeId("data-v-12d6b2d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "APP" }
const _hoisted_2 = {
  key: 1,
  class: "leftFloat"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "floatDiv",
  href: "https://mp.weixin.qq.com/s/FM88qvCOfTUokDznkOefyA",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, ""),
  /*#__PURE__*/_createElementVNode("p", null, "使用说明")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "floatDiv" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, ""),
  /*#__PURE__*/_createElementVNode("p", null, "遇到问题"),
  /*#__PURE__*/_createElementVNode("div", { class: "code" }, [
    /*#__PURE__*/_createElementVNode("p", null, "请添加管理员微信"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

import HeaderView from './components/HeaderView.vue'; 
import FooterView from './components/FooterView.vue'; 
import { useRoute } from 'vue-router'
import { ref,watchEffect } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const headershow=ref(true)
const footershow=ref(true)
watchEffect(()=>{     // 登录页面不显示头部
  if(route.path==="/LoginView"){
    headershow.value = false
    footershow.value = false
  }else{
    headershow.value = true
    footershow.value = true
  }
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (headershow.value)
      ? (_openBlock(), _createBlock(HeaderView, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, { class: "routerView" }),
    (headershow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    (footershow.value)
      ? (_openBlock(), _createBlock(FooterView, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}
}

})